import { HttpInterceptorFn } from '@angular/common/http';

import { environment } from '@env';

export const localeInterceptor: HttpInterceptorFn = (req, next) => {
  if (!req.url.startsWith(environment.apiUrl)) {
    return next(req);
  }
  if (req.headers.has('Accept-Language')) {
    return next(req);
  }
  return next(
    req.clone({
      setHeaders: { 'Accept-Language': environment.defaultLanguage },
    }),
  );
};
